import axios from 'axios';
import getApiBaseUrl from '../GetServer';

// Interfaz que representa la estructura de un ChatBot,
// puedes importarla desde 'GetChatBots.ts' si ya existe allí.
export interface ChatBot {
  id: number;
  idCliente: number;
  key: string;
  nombre:string;
  color: string;
  icono: string;
  status: number;
}

// Interfaz para la respuesta esperada del backend
interface ViewChatbotsResponse {
    status: number;
    message: string;
    data: ChatBot[];
}

export const viewChatbotsByClient = async (idClient: number): Promise<ViewChatbotsResponse> => {
    try {
        const baseUrl = getApiBaseUrl();
        const endpoint = `${baseUrl}dash/view-chatbots-by-client`;
        const token = localStorage.getItem('token');

        if (!token) {
            throw new Error('Token de autorización no disponible');
        }

        const response = await axios.post<ViewChatbotsResponse>(endpoint, idClient, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    } catch (error: any) {
        const errorMessage = error.response?.data?.message || 'Ocurrió un error al buscar los chatbots del cliente.';
        console.error('Error en viewChatbotsByClient:', errorMessage, error);
        throw new Error(errorMessage);
    }
};

